import React from "react";
import { FaFacebookF, FaWhatsapp, FaInstagram, FaEnvelope } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white text-sm py-4">
            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">

                {/* Social Icons (Left Side) */}
                <div className="flex space-x-4 mb-3 md:mb-0">
                    <a href="https://www.facebook.com/profile.php?id=61558009274205" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
                        <FaFacebookF size={20} />
                    </a>
                    <a href="https://www.instagram.com/supersaverz/" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500">
                        <FaInstagram size={20} />
                    </a>
                    <a href="mailto:contact@supersaverz.in" className="hover:text-gray-500">
                        <FaEnvelope size={20} />
                    </a>
                    {/* WhatsApp Icon */}
                    <a href="https://wa.me/9876788208" target="_blank" rel="noopener noreferrer" className="hover:text-green-500">
                        <FaWhatsapp size={20} />
                    </a>
                </div>

                {/* Explore Section (Right Side) */}
                <div className="flex space-x-6 text-gray-400">
                    <Link
                        to="/search?category=Footwear"
                        className="text-sm whitespace-nowrap hover:text-white transition-smooth"
                    >
                        👟 Explore Footwear
                    </Link>

                    {/* Explore Watches Link */}
                    <Link
                        to="/search?category=Smart Watches"
                        className="text-sm whitespace-nowrap hover:text-white transition-smooth"
                    >
                        ⌚ Explore Watches
                    </Link>
                </div>
            </div>

            {/* Divider */}
            <div className="w-full border-t border-gray-700 my-3"></div>

            {/* Copyright */}
            <p className="text-center text-gray-400">© 2025 SuperSaverz - A part of Nidhi Jain Group. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
